import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 30000,
  withCredentials: true,
  // headers: {
  //   Authorization: JSON.parse(localStorage.getItem('user'))?.apiToken,
  // }
});

axiosInstance.CancelToken = axios.CancelToken;
axiosInstance.isCancel = axios.isCancel;


export default axiosInstance;